import { type ReactElement } from 'react'
import { useRequiredParams } from '@util'
import { type ExternalLinkId, isExternalLinkId } from '@terros/common'
import { useProfile } from '@front/model'
import { Page, PermissionCheckWrapper } from '@components'
import { EditLink } from './EditLink'
import { createFileRoute } from '@tanstack/react-router'

function EditRoute(): ReactElement {
  const { externalLinkId } = useRequiredParams<{ externalLinkId: ExternalLinkId }>()
  const { company } = useProfile()

  if (!isExternalLinkId(externalLinkId)) {
    return (
      <Page.Hero title='Error' icon='error'>
        Link is not valid
      </Page.Hero>
    )
  }

  return (
    <PermissionCheckWrapper navigationTo='/' permissionType='externalLink:manage' targetId={[company?.companyId]}>
      <EditLink externalLinkId={externalLinkId} />
    </PermissionCheckWrapper>
  )
}

export const Route = createFileRoute('/settings/links_/$externalLinkId/')({
  component: EditRoute,
})
